module.exports = __webpack_public_path__ + "img/hilpolstein_hochaltar.e2786dea.jpg";